module.exports = __webpack_public_path__ + "static/media/part-05.0dd525ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-05.jpg
// module id = 934
// module chunks = 0